import { Col, Row } from 'reactstrap';
import { Watermarks } from '../../elements/Brand/Watermark';
import { Brands } from '../../elements/Brand/Brands';
import HelpLink from '../../elements/Help/HelpLink';
import { connect } from 'react-redux';
import Card, { CardBody, CardHeader, CardTitle } from '../../components/Card';
import { getTranslationKey } from '../../modules/utils/helpers';

const WatermarkAndBrand = ({ type }: { type: string }) => (
  <div className="animated fadeIn">
    <Row>
      <Col sm="12" md="12" lg="6">
        <Card style={{ height: '100%' }}>
          <CardHeader>
            <CardTitle>{getTranslationKey('userBrand.myBrands')}</CardTitle>
            {type === 'SB' && <HelpLink href="https://support.scrappbook.de/de/articles/61592" />}
          </CardHeader>
          <CardBody>
            <Brands />
          </CardBody>
        </Card>
      </Col>
      <Col sm="12" md="12" lg="6">
        <Card style={{ height: '100%' }}>
          <CardHeader>
            <CardTitle>{getTranslationKey('watermark.titleCard')}</CardTitle>
            {type === 'SB' && (
              <HelpLink href="https://support.scrappbook.de/de/collections/11559" />
            )}
          </CardHeader>
          <CardBody>
            <Watermarks />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

function mapStateToProps({ auth: { type } }: { auth: { type: string } }) {
  return { type };
}

export default connect(mapStateToProps, null)(WatermarkAndBrand);
